import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Checkbox,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
} from '@mui/material'
import { useStyles } from './styles'
import {useStyles as appointmentClasses} from '../styles'
import { useTranslation } from 'react-i18next'
import car from '../../../assets/images/tintedGlass/details_car.png'
import DatePicker from '../../../components/DateTimePicker/container/DatePicker'
import './styles.css'
import dateIcon from '../../../assets/icons/date.svg'
import { LocaleContext } from '../../../ts/routing/LangRouter'
import { format } from 'date-fns'
import ServiceTimePicker from '../../../components/ServiceTimePicker'
import axios from 'axios'
import {Controller} from "react-hook-form";
import clsx from "clsx";

const BasicCheckbox = ({ service, checked, onChange }) => {
    return (
        <Checkbox
            sx={{ p: 0 }}
            checked={checked}
            onChange={(e) => onChange(service.id, e.target.checked)}
        />
    )
}

BasicCheckbox.propTypes = {
    service: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }).isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
}

const Details = ({
                     additionalServices,
                     errors,
                     control,
                     setValue,
                     selectedServices,
                     setSelectedServices,
                     selectedTintGlass,
                     selectedDate,
                     register,
                     availableTimes,
                     fetchAvailableTimes,
                     resetTimeForm,
                 }) => {
    const classes = useStyles()
    const appointClasses = appointmentClasses()
    const { t } = useTranslation()
    const { locale } = useContext(LocaleContext)
    const [lang, setLang] = useState(locale)
    const [showDate, setShowDate] = useState(false)

    useEffect(() => {
        setLang(locale)
    }, [locale])

    const handleShowDate = () => setShowDate((show) => !show)
    const handleMouseDownPassword = (event) => event.preventDefault()

    const handleCheckboxChange = async (serviceId, isChecked) => {
        try {
            if (isChecked) {
                await axios.post(`${process.env.REACT_APP_API_KEY}/arscustom/public/appointment/add-additional-service`, {
                    additionalServiceId: serviceId
                })
                setSelectedServices((prev) => [...prev, serviceId])
            } else {
                await axios.post(`${process.env.REACT_APP_API_KEY}/arscustom/public/appointment/remove-additional-service`, {
                    additionalServiceId: serviceId
                })
                setSelectedServices((prev) => prev.filter((id) => id !== serviceId))
            }
            resetTimeForm() // Reset time and available times
        } catch (error) {
            console.error('Error updating service', error)
        }
    }

    function calculateDiscountPrice(originalPrice, discountPercentage) {
        const discountAmount = (originalPrice * discountPercentage) / 100
        const finalPrice = originalPrice - discountAmount
        return finalPrice % 1 === 0 ? finalPrice.toFixed(0) : finalPrice.toFixed(2)
    }

    const imageUrl = selectedTintGlass?.imageUrl || car

    return (
        <Box className={classes.container}>
            <p className={classes.title}>{t('appointment.booking_details')}</p>
            <Box className={classes.booking_details}>
                <img src={imageUrl} alt="car" className={classes.car} />
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        rowGap: '10px',
                    }}
                >
                    <Box className={classes.name}>
                        {lang === 'en' ? selectedTintGlass?.modelEn : selectedTintGlass?.modelFr}
                    </Box>
                    <Box className={classes.cost}>
                        {selectedTintGlass?.discount
                            ? calculateDiscountPrice(selectedTintGlass.price, selectedTintGlass.discount)
                            : selectedTintGlass?.price}{' '}
                        CHF
                    </Box>
                </Box>
            </Box>
            <Box
                className={
                    additionalServices.length > 2
                        ? classes.checkbox_wrapper
                        : classes.checkbox_wrapper_empty
                }
            >
                {additionalServices?.map((service) => (
                    <Box className={classes.checkbox_container} key={service.id}>
                        <label className={classes.label}>
                            <BasicCheckbox
                                service={service}
                                checked={selectedServices.includes(service.id)}
                                onChange={handleCheckboxChange}
                            />
                            <Box className={classes.text_wrapper}>
                                <Box className={classes.text}>
                                    {lang === 'en' ? service.descriptionEn : service.descriptionFr}
                                </Box>
                                <Box className={classes.cost}>
                                    {service.discount
                                        ? calculateDiscountPrice(service.price, service.discount)
                                        : service.price}{' '}
                                    CHF
                                </Box>
                            </Box>
                        </label>
                    </Box>
                ))}
            </Box>
            <Box className={classes.flex}>
                <Box className={classes.dateTime_wrapper}>
                    <p className={classes.booking_title}>{t('appointment.booking_date')}</p>
                    <Box sx={{ marginTop: '20px' }}>
                        <FormControl fullWidth className={classes.textfield}>
                            <InputLabel htmlFor="date" color="secondary">
                                Date
                            </InputLabel>
                            <Controller
                                name="date"
                                control={control}
                                render={({ field }) => (
                                    <OutlinedInput
                                        {...field}
                                        variant="outlined"
                                        required
                                        className={classes.textfield}
                                        error={errors.date ? true : false}
                                        fullWidth
                                        type="text"
                                        color="secondary"
                                        id="date"
                                        inputProps={{ min: 0, readOnly: true }}
                                        value={format(field?.value, 'dd/MM/yyyy')}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleShowDate}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    <img src={dateIcon} alt="date" />
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label="Date"
                                        onWheel={(event) => event.target.blur()}
                                    />
                                )}
                            />
                        </FormControl>
                        {errors.date && (
                            <span className={classes.error}>{errors.date?.message}</span>
                        )}
                        {showDate && (
                            <DatePicker
                                setValue={setValue}
                                handleShowDate={handleShowDate}
                            />
                        )}
                    </Box>
                    <Box sx={{ marginTop: '20px', width: '100%' }}>
                        <button
                            onClick={fetchAvailableTimes}
                            className={clsx(
                                t('form.fetch_times') === 'Fetch Times' ? appointClasses.en_btn : appointClasses.fr_btn,
                                appointClasses.btn_timer,
                                appointClasses.infoTab,
                            )}
                            style={{ marginBottom: '10px' }} // Smaller size
                        >
                            {t('form.fetch_times')}
                        </button>
                        <ServiceTimePicker
                            errors={errors}
                            register={register}
                            control={control}
                            selectedDate={selectedDate}
                            availableTimes={availableTimes}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

Details.propTypes = {
    register: PropTypes.any,
    errors: PropTypes.any,
    setError: PropTypes.func,
    control: PropTypes.any,
    setValue: PropTypes.func,
    selectedDate: PropTypes.any,
    selectedTime: PropTypes.any,
    availableTimes: PropTypes.array,
    additionalServices: PropTypes.array,
    selectedServices: PropTypes.array,
    setSelectedServices: PropTypes.func,
    selectedTintGlass: PropTypes.object,
    fetchAvailableTimes: PropTypes.func,
    resetTimeForm: PropTypes.func,
}

export default Details